export default class ContentSection{
	constructor(){
		const contentsections = document.querySelectorAll(".contentsection");
		contentsections.forEach(section=>{ this.initSection(section); });
	}
	initSection(section){
		const img1 = section.querySelector(".contentsection__img1");
		const img1_img = img1.querySelector("img");
		const img2 = section.querySelector(".contentsection__img2");
		const img2_img = img2.querySelector("img");
		const img3 = section.querySelector(".contentsection__img3");
		const img3_img = img3.querySelector("img");

		if(img1 && img1_img){
			gsap.fromTo(img1_img, {
				yPercent: 0,
			},{ 
				yPercent: 20,
				ease: "none",
				scrollTrigger: { 
					trigger: img1,
					start: "top bottom",
					endTrigger: img1,
					end: "bottom top",
					scrub: true,
					invalidateOnRefresh: true,
				}
			});
		}

		if(img2 && img2_img){
			gsap.fromTo(img2_img, {
				yPercent: 0,
			},{ 
				yPercent: 33.3333,
				ease: "none",
				scrollTrigger: { 
					trigger: img2,
					start: "top bottom",
					endTrigger: img2,
					end: "bottom top",
					scrub: true,
					invalidateOnRefresh: true,
				}
			});
		}

		if(img3 && img3_img){
			gsap.fromTo(img3_img, {
				yPercent: 0,
			},{ 
				yPercent: 33.3333,
				ease: "none",
				scrollTrigger: { 
					trigger: img3,
					start: "top bottom",
					endTrigger: img3,
					end: "bottom top",
					scrub: true,
					invalidateOnRefresh: true,
				}
			});
		}
	}
}